import { render, staticRenderFns } from "./DenominatorReports.vue?vue&type=template&id=38be8968"
import script from "./DenominatorReports.vue?vue&type=script&lang=js"
export * from "./DenominatorReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports